import React from 'react';

import { StyledCheckbox, StyledFormControlLabel } from './styles';

export default function CheckBox({
  label,
  value,
  slug,
  name,
  labelStyle,
  labelColor = '#464E5F',
  checkedColor,
  labelWeight = 400,
  ...rest
}) {
  const hasLabel = label !== undefined && label !== null && `${label}` !== '';
  const normalizedValue = value !== undefined && value !== null ? `${value}` : undefined;
  const normalizedId = slug !== undefined && slug !== null ? `perm_${slug}` : undefined;

  if (!hasLabel) {
    return (
      <StyledCheckbox
        $checkedColor={checkedColor}
        color="primary"
        value={normalizedValue}
        id={normalizedId}
        {...rest}
      />
    );
  }

  return (
    <>
      <StyledFormControlLabel
        style={labelStyle}
        $labelColor={labelColor}
        $labelWeight={labelWeight}
        control={
          <StyledCheckbox
            $checkedColor={checkedColor}
            color="primary"
            value={normalizedValue}
            id={normalizedId}
            {...rest}
          />
        }
        label={`${label}`}
      />
    </>
  );
}
